// extracted by mini-css-extract-plugin
export default {"p":"_5c2be4056f _064944bb1e _628a58fc8e","clr":"_1ca3885838","dls":"_94fbcb6e21"};